
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { BACKGROUND_CREATE, BACKGROUND_EDIT } from "@/route-names";
import BackgroundFilesGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse";
import EventBus from "@models/eventBus";
import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import ChangeSortIndexNewRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexNewRequest";
import SortIndexNewRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexNewRequest";
import TranslationItemModel from "@models/translationItemModel";
import { DragLiModel } from "@components/ui/models";
import { readPaginationCount, readPaginationItems } from "@/utils/pagination";
import PaginationRequest from "@/api/dataSource/api/Common/RequestModels/PaginationRequest";
import BackgroundCategoryListItem from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoryListItem";
import CategoryViewModel from "@models/categoryViewModel";

@Component
export default class PageAnimationComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  categories: CategoryViewModel[] = [];
  backgroundCategoryIds: { [backgroundId: string]: number } = {};
  animationCreateRouteName = BACKGROUND_CREATE;
  animationEditRouteName = BACKGROUND_EDIT;
  columnNames = [
    "#",
    "Фон",
    "Название",
    "Категория",
    "Порядок",
    "",
    "",
  ];
  getDataFunc = this.getBackgrounds.bind(this);
  removeFunc = this.$api.BackgroundFileService.deleteAsync.bind(
    this.$api.BackgroundFileService
  );
  async created() {
    const response = await this.$api.BackgroundCategoryService.getListAsync();
    this.categories = ((response && response.Items) || []).map(
      (item: BackgroundCategoryListItem) => new CategoryViewModel(item as any)
    );
  }
  async getBackgrounds(request: FilterRequest) {
    const response = await this.$api.BackgroundFileService.getListAsync(request);
    await this.refreshBackgroundCategoryIds(
      readPaginationItems<BackgroundFilesGetListResponse>(response)
    );
    return response;
  }
  startDelete(item: BackgroundFilesGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  filledTranslations(translations: any[]): any[] {
    return (translations || []).filter(
      (translation) =>
        translation &&
        typeof translation.Name === "string" &&
        translation.Name.trim()
    );
  }

  getCategoryName(categoryId: number): string {
    const normalizedCategoryId = categoryId == null ? null : Number(categoryId);
    const category = this.categories.find((item) => item.id === normalizedCategoryId);
    return category ? category.name : "";
  }

  getCategoryId(item: any): number {
    const categoryId = this.getBackgroundCategoryIdFromItem(item);
    if (categoryId != null) {
      return categoryId;
    }
    const backgroundId = item ? item.Id || item.id : "";
    return backgroundId ? this.backgroundCategoryIds[backgroundId] || null : null;
  }

  getBackgroundImageUrl(item: BackgroundFilesGetListResponse): string {
    return item ? item.BackImageUrl || item.Url || item.AnimationUrl : "";
  }

  async getList(): Promise<DragLiModel[]> {
    const pageSize = 100;
    const items: BackgroundFilesGetListResponse[] = [];
    let skip = 0;
    let total = 0;

    do {
      const response = await this.$api.BackgroundFileService.getListAsync(
        new FilterRequest({
          Pagination: new PaginationRequest({
            Skip: skip,
            Take: pageSize,
          }),
        })
      );
      const pageItems = readPaginationItems<BackgroundFilesGetListResponse>(
        response
      );
      items.push(...pageItems);
      total = readPaginationCount(response) || items.length;
      skip += pageSize;
    } while (items.length < total);

    if (!items.length) {
      return null;
    }

    return items.map(
      (item, index) =>
        new DragLiModel({
          Id: item.Id,
          SortIndex: item.SortIndex || index + 1,
          Image: this.getBackgroundImageUrl(item),
          Translate: this.filledTranslations(item.Translations).map(
            (translation) =>
              new TranslationItemModel({
                langCode: translation.LangCode,
                name: translation.Name,
              })
          ),
        })
    );
  }

  async changeSortIndex(items: DragLiModel[]): Promise<boolean> {
    const result = await this.$api.BackgroundFileService.changeSortIndexAsync(
      new ChangeSortIndexNewRequest({
        SortIndices: items.map(
          (item) =>
            new SortIndexNewRequest({
              Id: String(item.Id),
              SortIndex: item.SortIndex,
            })
        ),
      })
    );
    if (result) {
      this.$notification.success("Порядок успешно изменен.");
    }
    return Boolean(result);
  }

  async refreshBackgroundCategoryIds(itemsToResolve: BackgroundFilesGetListResponse[] = null): Promise<void> {
    if (!itemsToResolve || itemsToResolve.length === 0) {
      return;
    }

    const nextCategoryIds: { [backgroundId: string]: number } = { ...this.backgroundCategoryIds };
    itemsToResolve.forEach((item) => {
      const backgroundId = item ? item.Id || (item as any).id : "";
      const categoryId = this.getBackgroundCategoryIdFromItem(item);
      if (backgroundId && categoryId != null) {
        nextCategoryIds[backgroundId] = categoryId;
      }
    });

    this.backgroundCategoryIds = nextCategoryIds;
  }

  getBackgroundCategoryIdFromItem(item: any): number {
    const categoryId = item ? item.CategoryId ?? item.categoryId : null;
    const normalizedCategoryId = Number(categoryId);
    return Number.isFinite(normalizedCategoryId) && normalizedCategoryId > 0
      ? normalizedCategoryId
      : null;
  }
}
